import { createContext, createRef, MutableRefObject, useContext } from 'react';

const Layout = createContext<MutableRefObject<number | null>>(createRef());

export const LayoutProvider = ({
  children,
  scrollTopOffset,
}: React.PropsWithChildren<{
  scrollTopOffset: MutableRefObject<number | null>;
}>) => {
  return <Layout.Provider value={scrollTopOffset}>{children}</Layout.Provider>;
};

export const useScrollTopOffset = () => {
  return useContext(Layout);
};
